import { createRoot } from "@wordpress/element";
import App from "./components/App";

document.querySelectorAll(".wp-block-world-world-search-bar").forEach((el) => {
	const root = el.querySelector(".world-search-bar__app");
	if (root) {
		createRoot(root).render(<App />);
	}
});
